import IdGeneratorService from '@/services/id-generator.service';
import type { AutoCompleteProps } from 'primereact/autocomplete';
import { AutoComplete } from 'primereact/autocomplete';
import { FloatLabel } from 'primereact/floatlabel';
import { type Control, Controller } from 'react-hook-form';
import Container from '../container/Container';
import { TextBodyExtraExtraSmall } from '../text/Texts';

interface Props extends AutoCompleteProps {
	control: Control;
	formName: string;
	id: string;
	label?: string;
	suggestions: string[];
}

const AutoCompleteTextInput = (props: Props) => {
	const idService = new IdGeneratorService(props.formName);
	const idGenerated = idService.generateFormInputIds(props.id);
	return (
		<Controller
			control={props.control}
			name={props.id}
			render={({ field, fieldState: { error } }) => (
				<Container>
					<FloatLabel>
						<AutoComplete
							{...props}
							className={props.className ?? 'default-multiselect'}
							data-testid={idGenerated.testId}
							id={idGenerated.id}
							onChange={field.onChange}
							pt={props.pt}
							suggestions={props.suggestions}
							value={field.value}
						/>
						<label
							htmlFor={idGenerated.id}
							className={error ? 'error-label' : ''}
						>
							{props.label ?? idService.generateLabel(props.id)}
						</label>
					</FloatLabel>
					{error ? (
						<TextBodyExtraExtraSmall
							id={`${idGenerated.id}-helper`}
							className="block pl-[16px] mt-1 text-error"
							text={error?.message ?? ''}
						/>
					) : (
						''
					)}
				</Container>
			)}
		/>
	);
};

export default AutoCompleteTextInput;
